import { Button } from '@crazyegginc/hatch';
import { Modal } from '/src/contexts/modal';
import { WebP } from '/src/components/WebP';

import YellowWarningPNG from '@crazyegginc/hatch/dist/images/illustration-warning-yellow.png';
import YellowWarningWebP from '@crazyegginc/hatch/dist/images/illustration-warning-yellow.webp';

export function PlayerServiceWorkerError() {
  const compatibilityCheckUrl = `${window.MARKETING_BASE_URL}/compatibility`;

  return (
    <Modal disableOutsideClick={true} dismissable={false} dialogClassName="!p-6 !max-w-[440px]" dark>
      <div className="mb-5 mt-2 flex justify-center">
        <WebP webp={YellowWarningWebP} fallback={YellowWarningPNG} width="130px" height="102px" />
      </div>

      <Modal.Title className="text-center">Hmm, playback is blocked in this browser...</Modal.Title>

      <p className="text-body-2 text-center leading-5 text-white">
        This recording needs a browser feature that is currently blocked (service worker registration). Try disabling
        privacy extensions for this page, or open the recording in a different browser.
      </p>

      <Modal.Actions className="!justify-center">
        <Button component="a" href={compatibilityCheckUrl}>
          Compatibility Check
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
